import { Router, createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import { getToken, getAppId, setToken, treeDataTranslate } from '@/common/utils/index';
import { useLoginStore, useLayoutStore } from '@/store';
import { Dialog } from '@/components/Dialog';
import { ANY_OBJECT } from '@/types/generic';
import { routers } from './systemRouters';
import LoginController from '@/api/system/LoginController';

// 第三方页面路由跳转映射
const thirdRouteMap: ANY_OBJECT = {
  handlerFlowTask: 'thirdHandlerFlowTask',
};

// 创建路由实例
export const router: Router = createRouter({
  history: createWebHistory(),
  routes: routers,
  scrollBehavior(to, from, savedPosition) {
    return new Promise(resolve => {
      if (savedPosition) {
        return savedPosition;
      }
      if (from.meta.saveSrollTop) {
        const top: number = document.documentElement.scrollTop || document.body.scrollTop;
        resolve({ left: 0, top });
      }
    });
  },
});
router.beforeEach((to, from, next) => {
  if (to.name === 'login' || to.name === 'authLogin') {
    next();
  } else if (to.path.indexOf('/thirdParty/') !== -1) {
    // 第三方接入URL
    next();
  } else {
    // 取token信息判断是否登录
    const token = getToken();
    const toName: string = to.name as string;
    if (!token || !/\S/.test(token)) {
      const queryToken = to.query.token;
      if (queryToken) {
        let params: ANY_OBJECT = {
          userId: queryToken,
        };
        LoginController.authLogin(params)
          .then(data => {
            if (data.data.okFlag) {
              const layoutStore = useLayoutStore();
              const loginStore = useLoginStore();
              if (data.data.menuList) {
                layoutStore.setMenuList(
                  treeDataTranslate(data.data.menuList, 'menuId', 'parentId'),
                );
                delete data.data.menuList;
              }
              setToken(data.data.tokenData);
              layoutStore.setCurrentMenu(null);
              layoutStore.clearAllTags();
              if (data.data.tokenData) {
                delete data.data.tokenData;
              }
              loginStore.setUserInfo(data.data);
              // 登录成功跳转页面
              router.replace({ name: 'main' });
            } else {
              Dialog.closeAll();
              next({ name: 'login' });
            }
          })
          .catch(e => {
            Dialog.closeAll();
            next({ name: 'login' });
          });
      } else {
        Dialog.closeAll();
        next({ name: 'login' });
      }
    } else if (from.path.indexOf('/thirdParty/') !== -1 && thirdRouteMap[toName]) {
      // 第三方接入跳转页面，需要跳转到第三方的路由上
      let url =
        location.origin +
        location.pathname +
        '#/thirdParty/' +
        thirdRouteMap[toName] +
        '?appId=' +
        getAppId() +
        '&token=' +
        getToken();
      url += '&thirdParamsString=' + encodeURIComponent(JSON.stringify(to.query));
      location.href = url;
    } else {
      console.log(from);
      const layoutStore = useLayoutStore();
      if (from.meta.refreshParentCachedPage) {
        layoutStore.removeCachePage(toName);
        from.meta.refreshParentCachedPage = false;
      } else if (to.meta.keepAlive) {
        layoutStore.addCachePage(toName);
      }
      next();
    }
  }
});
export default router;
